// extracted by mini-css-extract-plugin
export default {"infoPill":"InfoPill_infoPill__z1Y6A","infoPill_primary":"InfoPill_infoPill_primary__Ur2dM","infoPill_community":"InfoPill_infoPill_community__oy-ZJ"};